import { FuelStop } from 'models/FuelStop';
import { Machine } from 'models//Machine';
import { MachineDefect } from 'models//MachineDefect';
import { MachineMaintenance } from 'models/MachineMaintenance';

export class MachineHistory {
    id: number;
    machine: Machine;
    serviceLife: number;
    date: Date;
    fuelStop?: FuelStop;
    machineDefects?: MachineDefect[];
    fixedMachineDefects?: MachineDefect[];
    machineMaintenances?: MachineMaintenance[];
    archivedDate?: Date;

    constructor(
        id: number,
        machine: Machine,
        serviceLife: number,
        date: Date,
        fuelStop: FuelStop,
        machineDefects: MachineDefect[],
        fixedMachineDefects: MachineDefect[],
        machineMaintenances: MachineMaintenance[],
        archivedDate?: Date
    ) {
        this.id = id;
        this.machine = machine;
        this.serviceLife = serviceLife;
        this.date = date;
        this.fuelStop = fuelStop
        this.machineDefects = machineDefects;
        this.fixedMachineDefects = fixedMachineDefects;
        this.machineMaintenances = machineMaintenances;
        this.archivedDate = archivedDate;
    }

    static empty(): MachineHistory {
        return { 
            id: 0,
            machine: Machine.empty(),
            serviceLife: 0,
            date: new Date(),
            fuelStop: FuelStop.empty(),
            machineDefects: undefined,
            fixedMachineDefects: undefined,
            machineMaintenances: undefined,
        };
    }
    static emptyDailyReport(): MachineHistory {
        return { 
            id: 0,
            machine: Machine.empty(),
            serviceLife: 0,
            date: new Date(),
            fuelStop: FuelStop.empty(),
            machineDefects: [MachineDefect.empty()],
        };
    }
    static editDailyReport(mh: MachineHistory): MachineHistory {
        return { 
            id: mh.id,
            machine: mh.machine,
            serviceLife: mh.serviceLife,
            date: mh.date,
            fuelStop: mh.fuelStop ?? FuelStop.empty(),
            machineDefects: mh.machineDefects ?? undefined,
        };
    }
}